<template>
  <div class="model-course">
    <div class="place p-1 depatureStation">
      <div class="course-icon ml-1">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8.73054 20.5778L10.4491 18.8174H13.7605L15.479 20.5778H17.2395V20.1377L15.9401 18.8174C16.485 18.8174 16.995 18.6811 17.4701 18.4087C17.9451 18.1362 18.3189 17.7695 18.5913 17.3084C18.8638 16.8473 19 16.3373 19 15.7784V7.47904C19 6.501 18.6786 5.74651 18.0359 5.21557C17.477 4.74052 16.6387 4.40519 15.521 4.20958C14.6547 4.06986 13.481 4 12 4C10.6307 4 9.51297 4.06986 8.64671 4.20958C7.501 4.40519 6.63473 4.74052 6.0479 5.21557C5.3493 5.76048 5 6.51497 5 7.47904V15.7784C5 16.3373 5.13972 16.8473 5.41916 17.3084C5.6986 17.7695 6.07236 18.1362 6.54042 18.4087C7.00848 18.6811 7.52196 18.8174 8.08084 18.8174L6.76048 20.1377V20.5778H8.73054ZM17.2395 10.9581H12.8593V7.47904H17.2395V10.9581ZM11.1407 10.9581H6.76048V7.47904H11.1407V10.9581ZM15.9401 17.0988C15.5629 17.0988 15.2485 16.9696 14.997 16.7111C14.7455 16.4526 14.6198 16.1417 14.6198 15.7784C14.6198 15.4152 14.749 15.1078 15.0075 14.8563C15.266 14.6048 15.5768 14.479 15.9401 14.479C16.3034 14.479 16.6108 14.6013 16.8623 14.8458C17.1138 15.0903 17.2395 15.4012 17.2395 15.7784C17.2395 16.1557 17.1138 16.4701 16.8623 16.7216C16.6108 16.9731 16.3034 17.0988 15.9401 17.0988V17.0988ZM8.08084 17.0988C7.70359 17.0988 7.38922 16.9696 7.13772 16.7111C6.88623 16.4526 6.76048 16.1417 6.76048 15.7784C6.76048 15.4152 6.88972 15.1078 7.1482 14.8563C7.40669 14.6048 7.71756 14.479 8.08084 14.479C8.44411 14.479 8.7515 14.6013 9.00299 14.8458C9.25449 15.0903 9.38024 15.4012 9.38024 15.7784C9.38024 16.1557 9.25449 16.4701 9.00299 16.7216C8.7515 16.9731 8.44411 17.0988 8.08084 17.0988V17.0988Z" fill="white"/>
        </svg>
      </div>
      <div class="font-bold text-white ml-1">
        {{ course.departure }}
      </div>
    </div>
    <div class="course-detail pl-2 ml-5 py-2">
      &nbsp;
    </div>
    <div v-for="(place, index) in course.places" :key="index">
      <div class="place p-1">
        <div class="course-number w-6 h-6 ml-1 text-center border font-bold flex-shrink-0">
          {{ index + 1 }}
        </div>
        <div class="font-bold text-white ml-1">
          {{ place.name }}
        </div>
      </div>
      <div class="course-detail pl-2 ml-5 py-2">
        <div v-if="place.images && place.images.length > 0">
          <img v-lazy="place.images[imageIndex[index]]" class="course-image" />
          <div v-if="place.images.length >= 2" class="text-center">
            <span><a @click="prevImage(index)" class="text-gray-600 text-sm" :class="imageIndex[index] > 0 ? 'visible' : 'invisible'">＜ 前の画像</a></span>
            ({{ imageIndex[index] + 1 }}/{{ place.images.length }})
            <span><a @click="nextImage(index)" class="text-gray-600 text-sm" :class="imageIndex[index] < place.images.length - 1 ? 'visible' : 'invisible'">次の画像 ＞</a></span>
          </div>
        </div>
        <div class="text-sm" v-html="place.detail.replace(/\n/g, '<br />')" />
        <div v-if="!createPlan" class="my-2">
          <a @click="showMap(place)" class="btn-map">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="mr-1">
              <path d="M9.18746 8.81266L3.40381 10.4691C3.13624 10.5458 2.93311 10.7643 2.87617 11.0367L0.741076 21.2527C0.628783 21.79 1.11277 22.262 1.64707 22.1362L8.62341 20.494C8.73747 20.4671 8.85623 20.4674 8.97017 20.4947L15.1435 21.9751C15.2547 22.0018 15.3705 22.0026 15.4821 21.9777L22.7578 20.3501C23.1599 20.2601 23.4141 19.8625 23.3271 19.4597L21.2569 9.88016C21.1676 9.46677 20.7543 9.20896 20.3438 9.31052L15.3628 10.5427C15.2278 10.5761 15.0861 10.5713 14.9537 10.5288L9.62297 8.81949C9.48167 8.77418 9.33011 8.77181 9.18746 8.81266Z" class="icon-fill" />
              <path d="M9.00002 10L3.75002 11.625L2.06252 20.8125L8.31252 19.3125L9.00002 10Z" fill="white"/>
              <path d="M14.7969 11.5625L9.6875 9.78125L9.125 19.3438L14.7969 20.6094V11.5625Z" fill="white"/>
              <path d="M20.3125 10.5C20.3125 10.5 15.6094 11.5625 15.5469 11.5625V20.7188L21.9844 19.1875L20.3125 10.5Z" fill="white"/>
              <path d="M11.75 1C14.3755 1 16.5 3.11863 16.5 5.73685C16.5 6.3012 16.4351 6.88405 16.1938 7.39289L12.8169 14.5537C12.6221 14.9607 12.1953 15.2105 11.75 15.2105C11.3047 15.2105 10.8779 14.9607 10.6924 14.5537L7.30615 7.39289C7.06494 6.88405 7 6.3012 7 5.73685C7 3.11863 9.12451 1 11.75 1V1ZM11.75 3.36842C10.5107 3.36842 9.5 4.40508 9.5 5.67612C9.5 6.94715 10.5107 7.98381 11.75 7.98381C12.9893 7.98381 14 6.94715 14 5.67612C14 4.40508 12.9893 3.36842 11.75 3.36842V3.36842Z" class="icon-fill" />
              </svg>  
            マップで見る
          </a>
        </div>
      </div>
    </div>
    <div class="place">
      <div class="course-icon ml-1 mr-1 p-1">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8.73054 20.5778L10.4491 18.8174H13.7605L15.479 20.5778H17.2395V20.1377L15.9401 18.8174C16.485 18.8174 16.995 18.6811 17.4701 18.4087C17.9451 18.1362 18.3189 17.7695 18.5913 17.3084C18.8638 16.8473 19 16.3373 19 15.7784V7.47904C19 6.501 18.6786 5.74651 18.0359 5.21557C17.477 4.74052 16.6387 4.40519 15.521 4.20958C14.6547 4.06986 13.481 4 12 4C10.6307 4 9.51297 4.06986 8.64671 4.20958C7.501 4.40519 6.63473 4.74052 6.0479 5.21557C5.3493 5.76048 5 6.51497 5 7.47904V15.7784C5 16.3373 5.13972 16.8473 5.41916 17.3084C5.6986 17.7695 6.07236 18.1362 6.54042 18.4087C7.00848 18.6811 7.52196 18.8174 8.08084 18.8174L6.76048 20.1377V20.5778H8.73054ZM17.2395 10.9581H12.8593V7.47904H17.2395V10.9581ZM11.1407 10.9581H6.76048V7.47904H11.1407V10.9581ZM15.9401 17.0988C15.5629 17.0988 15.2485 16.9696 14.997 16.7111C14.7455 16.4526 14.6198 16.1417 14.6198 15.7784C14.6198 15.4152 14.749 15.1078 15.0075 14.8563C15.266 14.6048 15.5768 14.479 15.9401 14.479C16.3034 14.479 16.6108 14.6013 16.8623 14.8458C17.1138 15.0903 17.2395 15.4012 17.2395 15.7784C17.2395 16.1557 17.1138 16.4701 16.8623 16.7216C16.6108 16.9731 16.3034 17.0988 15.9401 17.0988V17.0988ZM8.08084 17.0988C7.70359 17.0988 7.38922 16.9696 7.13772 16.7111C6.88623 16.4526 6.76048 16.1417 6.76048 15.7784C6.76048 15.4152 6.88972 15.1078 7.1482 14.8563C7.40669 14.6048 7.71756 14.479 8.08084 14.479C8.44411 14.479 8.7515 14.6013 9.00299 14.8458C9.25449 15.0903 9.38024 15.4012 9.38024 15.7784C9.38024 16.1557 9.25449 16.4701 9.00299 16.7216C8.7515 16.9731 8.44411 17.0988 8.08084 17.0988V17.0988Z" fill="white"/>
        </svg>
      </div>
      <div class="font-bold text-white">
        {{ course.arrival }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CoursePLaces',
  props: {
    course: {
      type: Object
    },
    createPlan: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data () {
    return {
      place: null,
      modal: {
        show: false
      },
      imageIndex: null
    }
  },
  created () {
    this.imageIndex = Array(10)
    this.imageIndex.fill(0)
  },
  methods: {
    showMap: function (place) {
      const location = place.location
      const params = {
        lat: location.latitude,
        lng: location.longitude
      }
      this.$store.dispatch('map/updateCenter', params)
      this.$store.dispatch('map/updateFrom', { name: 'courses', courseId: this.course.course_id })
      this.$emit('openMap')
    },
    prevImage: function (index) {
      this.imageIndex[index]--
      this.imageIndex.splice()
    },
    nextImage: function (index) {
      this.imageIndex[index]++
      this.imageIndex.splice()
    }
  }
}
</script>
